import { css } from '@emotion/react';
import { darkThemeStyle } from '../theme';
import { tokens } from '../tokens';
// Mapping between heading size, HTML elements, and actual font size
const sizeMap = {
    large: {
        element: 'h3',
        fontSize: tokens.fontSizes.large,
    },
    medium: {
        element: 'h4',
        fontSize: tokens.fontSizes.medium,
    },
    xlarge: {
        element: 'h2',
        fontSize: tokens.fontSizes.xlarge,
    },
    xxlarge: {
        element: 'h1',
        fontSize: tokens.fontSizes.xxlarge,
    },
};
const headingStaticStyle = css({
    fontWeight: tokens.fontWeights.bold,
    lineHeight: tokens.lineHeights.default,
    marginBottom: tokens.spacingNew.xsmall,
});
export function headingStyle({ inverted, size }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        headingStaticStyle,
        css({
            fontSize: sizeMap[size].fontSize,
        }),
    ];
}
export function sizeToElement({ size }) {
    return sizeMap[size].element;
}
